"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPersonalReservablesAndBestReservables = void 0;
var __1 = require("../../..");
var dates_1 = require("../../dates");
var sorting_1 = require("../../sorting");
var getPersonalBestReservablesAroundReservation = function (reservationDay, reservation, unreservedByDay) {
    // used to only get first match within x amount of minutes before reservation
    var unreservedsOnReservationDay = unreservedByDay[reservationDay];
    if (unreservedsOnReservationDay) {
        var ascendingUnReserveds = Array.prototype.slice
            .call(unreservedsOnReservationDay)
            .sort(sorting_1.compareStartDatesDescending);
        var bestReservableBeforeReservation = ascendingUnReserveds.find(function (unreserved) {
            var differenceBetweenReservationAndReservable = dates_1.getDifferenceDurationInMinutes(unreserved.endDate, reservation.startDate);
            return differenceBetweenReservationAndReservable <= 0 && differenceBetweenReservationAndReservable >= -31;
        });
        var bestReservableAfterReservation = unreservedsOnReservationDay.find(function (unreserved) {
            var differenceBetweenReservationAndReservable = dates_1.getDifferenceDurationInMinutes(unreserved.startDate, reservation.endDate);
            return differenceBetweenReservationAndReservable >= 0 && differenceBetweenReservationAndReservable <= 31;
        });
        var bestReservables = __spreadArrays((bestReservableBeforeReservation ? [bestReservableBeforeReservation] : []), (bestReservableAfterReservation ? [bestReservableAfterReservation] : []));
        if (bestReservables.length > 0) {
            return bestReservables;
        }
    }
};
/** in some cases a reservable matches with a reservation before and after it, removes duplicate */
var removeDuplicateBestReservables = function (bestReservables) {
    return bestReservables.filter(function (bestReservable, index) { var _a; return bestReservable.showingId !== ((_a = bestReservables[index + 1]) === null || _a === void 0 ? void 0 : _a.showingId); });
};
var getPersonalReservablesAndBestReservables = function (reservedShowings, unreservedShowings) {
    var bestReservables = [];
    var reservables = [];
    var reservedByDay = __1.groupByDays(reservedShowings);
    var unreservedByDay = __1.groupByDays(unreservedShowings);
    Object.entries(unreservedByDay).forEach(function (_a) {
        var showingsDay = _a[0], unreservedOfTheDay = _a[1];
        if (!reservedByDay[showingsDay]) {
            reservables = __spreadArrays(reservables, unreservedOfTheDay);
        }
    });
    Object.entries(reservedByDay).forEach(function (_a) {
        var reservationDay = _a[0], reservedShowingsOfTheDay = _a[1];
        reservedShowingsOfTheDay.forEach(function (reservedShowing) {
            var reservationDayBestReservables = getPersonalBestReservablesAroundReservation(reservationDay, reservedShowing, unreservedByDay);
            if (reservationDayBestReservables) {
                bestReservables = __spreadArrays(bestReservables, reservationDayBestReservables);
            }
        });
    });
    return { bestReservables: removeDuplicateBestReservables(bestReservables), reservables: reservables };
};
exports.getPersonalReservablesAndBestReservables = getPersonalReservablesAndBestReservables;
//# sourceMappingURL=personalReservables.js.map